<div class="px-3">
<svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
<g id="ev_charger">
<mask
        id="mask0_4545_22576"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
<rect id="Bounding box" x="0.5" width="24" height="24" fill="#D9D9D9" />
</mask>
<g mask="url(#mask0_4545_22576)">
<path
          id="ev_charger_2"
          d="M9 19L11.5 15H10V12L7.5 16H9V19ZM6.5 10H12.5V5H6.5V10ZM6.5 19H12.5V12H6.5V19ZM4.5 21V5C4.5 4.45 4.69583 3.97917 5.0875 3.5875C5.47917 3.19583 5.95 3 6.5 3H12.5C13.05 3 13.5208 3.19583 13.9125 3.5875C14.3042 3.97917 14.5 4.45 14.5 5V12H15.75C16.2333 12 16.6458 12.1708 16.9875 12.5125C17.3292 12.8542 17.5 13.2667 17.5 13.75V18.375C17.5 18.6583 17.6167 18.9167 17.85 19.15C18.0833 19.3833 18.3417 19.5 18.625 19.5C18.925 19.5 19.1875 19.3833 19.4125 19.15C19.6375 18.9167 19.75 18.6583 19.75 18.375V9H19.5C19.2167 9 18.9792 8.90417 18.7875 8.7125C18.5958 8.52083 18.5 8.28333 18.5 8V6H19V4.5H20V6H21V4.5H22V6H22.5V8C22.5 8.28333 22.4042 8.52083 22.2125 8.7125C22.0208 8.90417 21.7833 9 21.5 9H21.25V18.375C21.25 19.075 20.9958 19.6875 20.4875 20.2125C19.9792 20.7375 19.3583 21 18.625 21C17.9083 21 17.2917 20.7375 16.775 20.2125C16.2583 19.6875 16 19.075 16 18.375V13.75C16 13.6667 15.9792 13.6042 15.9375 13.5625C15.8958 13.5208 15.8333 13.5 15.75 13.5H14.5V21H4.5Z"
          fill="#002987"
        />
</g>
</g>
</svg>
</div>
